(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    if (!window.familyBuyNowPreservesCart) {
    window.familyBuyNowPreservesCart = true;

    document.addEventListener(
      'click',
      async (event) => {
        const button = event.target.closest('[data-family-buy-now]');
        if (!(button instanceof HTMLButtonElement) || button.disabled) return;

        const form = button.closest('form');
        if (!form || !form.reportValidity()) return;

        event.preventDefault();
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');

        const formData = new FormData(form);
        formData.delete('sections');
        formData.delete('sections_url');

        try {
          const response = await fetch(button.dataset.cartAddUrl, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData,
          });
          const result = await response.json();

          if (!response.ok || result.status) {
            throw new Error(result.description || result.message || 'Unable to add the product to the cart');
          }

          window.location.assign(button.dataset.checkoutUrl);
        } catch (error) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          console.error(error);
        }
      },
      true
    );
  }
  } catch(e) { console.error(e); }
})();

})();
